/**
 * Keeps the user gesture's new tab alive while the backend produces a PDF, avoiding popup blockers.
 */
export function openFinancialReportPdf(blob: Blob, target: Window | null): void {
    const url = URL.createObjectURL(blob);
    if (target && !target.closed) {
        target.location.href = url;
        target.focus();
    } else {
        window.open(url, '_blank');
    }
    window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

export function closeFinancialReportPdf(target: Window | null): void {
    if (target && !target.closed) target.close();
}

export function downloadFinancialReportPdf(blob: Blob, reportCode: string): void {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${reportCode}_${new Date().toISOString().slice(0, 10)}.pdf`;
    link.click();
    window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
